import React, { ReactElement } from "react"
import { Trans } from "@lingui/macro"
import PhoneNumber from "../PhoneNumber/PhoneNumber"
import ErrorBox from "./ErrorBox"
import styles from "./FatalBox.module.scss"

type Props = {
    onButtonClick: () => void
    buttonLabel: string | ReactElement
}

const FatalBox: React.FC<Props> = ({ onButtonClick, buttonLabel }) => {
    return (
        <ErrorBox
            message={
                <>
                    <div className={styles.messageBox}>
                        <Trans>Need assistance? Call our Reservation Team</Trans>
                    </div>
                    <PhoneNumber className={styles.phoneNumber} />
                </>
            }
            button={{
                label: buttonLabel,
                onClick: onButtonClick,
            }}
        />
    )
}

export default FatalBox
